import { Injectable } from '@angular/core';
import { Urls } from '@core/config';
import { BaseApiService } from '@smartera/core';

@Injectable()
export class AnalyzeFunctionExecutionLogService extends BaseApiService<any> {
	override get apiUrl() {
		return `${Urls.BASE_URL.toString()}/analytic/analyze-execution-logs`;
	}
}
